// removed by extract-text-webpack-plugin
module.exports = {"main":"_3ZKYPa35cTTcDUqhhLCaGt","searchInput":"yaLPz-dc8N5TX3SMdEln-"};


//////////////////
// WEBPACK FOOTER
// ./components/Customers/CustomersProfiles/index.module.css
// module id = 2343
// module chunks = 1